import z from "zod";

import {
  countPhoneDigits,
  PHONE_MAX_LENGTH,
  PHONE_MIN_DIGIT_COUNT,
} from "@/lib/utils/phone/phone";

export const PHONE_REQUIREMENTS_HELP_TEXT = `Phone number must be at most ${PHONE_MAX_LENGTH} characters and contain at least ${PHONE_MIN_DIGIT_COUNT} digits.`;

export const PHONE_VALIDATION_ERROR_PATTERN =
  /Phone number must contain at least 10 digits|Phone number must be at most 24 characters|Phone number is required/i;

export function getPhoneValidationError(phone: string): string | null {
  if (!phone || typeof phone !== "string" || phone.trim().length === 0) {
    return "Phone number is required";
  }

  if (phone.length > PHONE_MAX_LENGTH) {
    return `Phone number must be at most ${PHONE_MAX_LENGTH} characters`;
  }

  if (countPhoneDigits(phone) < PHONE_MIN_DIGIT_COUNT) {
    return `Phone number must contain at least ${PHONE_MIN_DIGIT_COUNT} digits`;
  }

  return null;
}

export function getOptionalPhoneValidationError(
  phone: string | undefined | null,
): string | null {
  if (!phone || phone.trim() === "") {
    return null;
  }

  if (phone.length > PHONE_MAX_LENGTH) {
    return `Phone number must be at most ${PHONE_MAX_LENGTH} characters`;
  }

  if (countPhoneDigits(phone) < PHONE_MIN_DIGIT_COUNT) {
    return `Phone number must contain at least ${PHONE_MIN_DIGIT_COUNT} digits`;
  }

  return null;
}

export const phoneZodField = z.string().superRefine((val, ctx) => {
  const error = getPhoneValidationError(val);
  if (error) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: error });
  }
});

export const optionalPhoneZodField = z
  .string()
  .optional()
  .or(z.literal(""))
  .superRefine((val, ctx) => {
    const error = getOptionalPhoneValidationError(val);
    if (error) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: error });
    }
  });
